<template>
  <div class="recommendation-template">
    <div ref="headerElement" class="recommendation-template-header">
      <slot name="header" />
    </div>
    <div ref="contentElement" class="recommendation-template-content">
      <slot />
    </div>
  </div>
</template>
<script setup lang="ts">
import { gsap } from 'gsap';

interface Props {
  ready: boolean;
}
const props = defineProps({
  ready: { type: Boolean }
});

watchEffect(() => {
  if (props.ready) {
    playAnimation();
  }
});
const headerElement = ref(null);

const contentElement = ref(null);

let timeline;

const playAnimation = () => {
  timeline.play();
};

onMounted(() => {
  timeline = gsap.timeline({ delay: 0 });
  timeline.fromTo(
    headerElement.value,
    { opacity: 0 },
    { opacity: 1, duration: 0.1, ease: 'power1.out' },
    0.1
  );
  timeline.fromTo(
    headerElement.value,
    { y: 100 },
    { y: 0, duration: 0.8, ease: 'elastic.out(1,0.8)' },
    0.1
  );

  timeline.fromTo(
    contentElement.value,
    { opacity: 0 },
    { opacity: 1, duration: 0.1, ease: 'power1.out' },
    0.15
  );
  timeline.fromTo(
    contentElement.value,
    { y: 140 },
    { y: 0, duration: 0.7, ease: 'elastic.out(1,0.9)' },
    0.15
  );
});

onUnmounted(() => {
  if (timeline) timeline.kill();
});
</script>
<style lang="scss" scoped>
.recommendation-template {
  display: flex;
  position: relative;
  flex-direction: column;
  width: 100%;
  gap: var(--gap_n);
  &-header {
    min-height: 3rem;
    color: var(--color_neutral_25);
    @include font('m', 600);
  }
  &-content {
    display: flex;
    width: stretch;
  }
}
</style>
